import React from 'react';

type SearchboxMatchProps = {
    value: string;
    query: string;
};

export function SearchboxMatch(props: SearchboxMatchProps) {
    const { query, value } = props;

    if (!query || !value) {
        return <>{value}</>;
    }

    return <>{renderHighlightedTerm(query, value)}</>;
}

function renderHighlightedTerm(term: string, text: string) {
    // Turn "Term Term1 " into /(^|\s)(Term1|Term)/, the terms being escaped.
    // `(^|\s)` is added to only highlight beginning of words.
    const pattern = `(^|\\s)(${term
        .trim()
        .split(/\s+/)
        // Sort by length (longest first) since the matching is eager, e.g.:
        //  Bad:  "t t1".match(/t|t1/gi) -> ["t", "t"]
        //  Good: "t t1".match(/t1|t/gi) -> ["t", "t1"]
        .sort((term1, term2) => term2.length - term1.length)
        .map(escapeRegExp)
        .join('|')})`;

    const highlightRegExp = new RegExp(pattern, 'gi');

    const highlightMatches = text.match(highlightRegExp);
    if (!highlightMatches) {
        return text;
    }

    const termsToHighlight = highlightMatches.map((s) => s.trim()); // some matches might include whitespace

    return text
        .split(highlightRegExp)
        .filter(Boolean)
        .map((value, index) =>
            termsToHighlight.indexOf(value) === -1 ? (
                value
            ) : (
                <b className="query" key={index}>
                    {value}
                </b>
            ),
        );
}

function escapeRegExp(s: string) {
    // https://github.com/tc39/proposal-regex-escaping/blob/main/polyfill.js
    return String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
}
